"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _immutable = require("immutable");

var _firekit = require("./firekit");

var _firekit2 = _interopRequireDefault(_firekit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
hoc(UserLogoutButton, (Component)=>[
    withUser(Component()),
    waitForLoad(Component()),
    firebind(Component(), {
        books: "books",
        book: ({bookId})=>`books/${bookId}/`
    }),
])
*/

/* fireBind - bind to data in firebase to named props

 fireBind(<Component>, {
 prop: (props)=> {
 ref: `/base/endpoint/${props.dynamicValue}`,
 asArray: false,
 queries: {
 }
 ... rebaseOptions
 },
 prop2: ({prop})=> `/shortcut/for/ref`
 }

 */

var firebind = function firebind(BoundComponent, propMap, rebase) {
    return function (_React$Component) {
        _inherits(Firebind, _React$Component);

        function Firebind(props) {
            _classCallCheck(this, Firebind);

            var _this = _possibleConstructorReturn(this, (Firebind.__proto__ || Object.getPrototypeOf(Firebind)).call(this, props));

            _this.state = {};
            _this.subs = {};
            _this.mounted = false;
            _this.result = (0, _immutable.OrderedMap)();

            _this.rebase = rebase || (0, _firekit2.default)().rebase;
            return _this;
        }

        _createClass(Firebind, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                this.updateSubscriptions(true);
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateSubscriptions(false);
            }
        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this2 = this;

                this.mounted = false;
                (0, _immutable.OrderedMap)(this.subs).forEach(function (sub) {
                    return _this2.unsubscribeOne(sub);
                });
            }
        }, {
            key: "render",
            value: function render() {
                var _this3 = this;

                var anyUnloadedData = this.result.keySeq().some(function (k) {
                    return _this3.state[k] === undefined;
                });
                var loading = this.result.count() === 0 || anyUnloadedData;
                return _react2.default.createElement(BoundComponent, _extends({}, this.props, this.state, { loading: loading }));
            }
        }, {
            key: "updateSubscriptions",
            value: function updateSubscriptions(initialSubscription) {
                var _this4 = this;

                var data = _extends({}, this.state, this.props);

                var newResult = (0, _immutable.OrderedMap)(propMap).map(function (configurator, name) {
                    var config = typeof configurator === "function" ? configurator(data) : configurator;
                    // Single string values are interpreted to be the ref
                    config = (typeof config === "undefined" ? "undefined" : _typeof(config)) === "object" ? config : { ref: config };
                    return (0, _immutable.fromJS)({ name: name, value: config });
                });

                var unsubscribe = this.result.toOrderedSet().subtract(newResult.toOrderedSet());
                var subscribe = newResult.toOrderedSet().subtract(this.result.toOrderedSet());

                unsubscribe.forEach(function (map) {
                    var name = map.get("name");
                    _this4.unsubscribeOne(name, subscribe.has(name));
                });
                subscribe.forEach(function (map) {
                    _this4.subscribeOne(map, initialSubscription);
                });

                this.result = newResult;
            }
        }, {
            key: "unsubscribeOne",
            value: function unsubscribeOne(name, removeState) {
                var sub = this.subs[name];
                delete this.subs[name];
                sub && this.rebase.removeBinding(sub);
                if (removeState) {
                    this.set(name, null);
                }
            }
        }, {
            key: "set",
            value: function set(key, value) {
                if (this.mounted) {
                    this.setState(_defineProperty({}, key, value));
                }
            }
        }, {
            key: "subscribeOne",
            value: function subscribeOne(nameValueMap) {
                var name = nameValueMap.get("name");
                var value = nameValueMap.get("value").toJS();
                if (this.props[name]) {
                    this.set(name, this.props[name]);
                }

                if (value.ref !== undefined) {
                    if (this.subs[name]) {
                        this.unsubscribeOne(name);
                    }
                    if (typeof value.ref !== "string") {
                        this.set(name, value.ref);
                    } else {
                        this.subs[name] = this.rebase.bindToState(value.ref, _extends({
                            context: this,
                            state: name
                        }, value, {
                            onFailure: function onFailure() {
                                var _console;

                                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                                    args[_key] = arguments[_key];
                                }

                                (_console = console).error.apply(_console, ["Binding '%s' => '%s' failed: ", name, value.ref].concat(args));
                                value.onFailure && value.onFailure.apply(value, args);
                            }
                        }));
                    }
                }
            }
        }]);

        return Firebind;
    }(_react2.default.Component);
};
exports.default = firebind;